import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Roles',
    href: '#roles'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }, {
    name: 'Testimonials',
    href: '#testimonials'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/80 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-173">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-174">
        <a href="#" className="flex items-center gap-2 group" data-id="element-175">
          <img src="https://cdn.magicpatterns.com/uploads/1PpJJn6acek23xVhxTKqe6/FullLogo_Transparent_(2).png" alt="TALVORI Talent" className="h-12 w-auto object-contain group-hover:scale-105 transition-transform" data-id="element-176" />
          <span className={`font-display font-bold text-2xl tracking-tight transition-colors ${isScrolled ? 'text-navy' : 'text-white'}`} data-id="element-177">
            TALVORI
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8" data-id="element-178">
          {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium transition-colors ${isScrolled ? 'text-slate-600 hover:text-navy' : 'text-slate-200 hover:text-white'}`} data-id="element-179">
              {link.name}
            </a>)}
        </nav>

        <div className="hidden md:block" data-id="element-180">
          <a href="https://calendly.com/partners-talvoritalents/30min?month=2026-06" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-2.5 text-sm font-semibold text-navy bg-white border border-slate-200 rounded-full hover:bg-slate-100 transition-colors shadow-soft hover:shadow-soft-lg" data-id="element-181">
            Book a Free Consultation
          </a>
        </div>

        <button className={`md:hidden p-2 transition-colors ${isScrolled ? 'text-slate-600' : 'text-white'}`} onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-182">
          {mobileMenuOpen ? <X size={24} data-id="element-183" /> : <Menu size={24} data-id="element-184" />}
        </button>
      </div>

      <AnimatePresence data-id="element-185">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 right-0 bg-white shadow-soft-lg border-t border-slate-100 md:hidden" data-id="element-186">
            <div className="flex flex-col px-6 py-4 gap-4" data-id="element-187">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-medium text-slate-800 py-2" onClick={() => setMobileMenuOpen(false)} data-id="element-188">
                  {link.name}
                </a>)}
              <a href="https://calendly.com/partners-talvoritalents/30min?month=2026-06" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 mt-2 text-sm font-semibold text-white bg-navy rounded-full" onClick={() => setMobileMenuOpen(false)} data-id="element-189">
                Book a Free Consultation
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}